// a mock import of RNFS, because it isn't needed for web, but it also isnot supported for web

const RNFS = {
  TemporaryDirectoryPath: "",
};

export default RNFS;